export const HEIGHT = '11px';
export const DEFAULT_WIDTH = '100%';
